module.exports = __webpack_public_path__ + "img/logo.2418adc0.svg";